export type EmptyFunction = () => void;
export const emptyFunction: EmptyFunction = () => {};
